import React, { useState, useRef, useEffect } from 'react';
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import "../../App.css";
import Login from '../Login/Login';

const indianGames = [
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/98789.webp",
    alt: "Live Teenpatti",
    title: "Live Teenpatti",
    provider_code: "SN",
    game_code: "TP",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67660.webp",
    alt: "2 Cards Teenpatti",
    title: "2 Cards Teenpatti",
    provider_code: "SN",
    game_code: "TPFO",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/56768.webp",
    alt: "TENNPATTI T20",
    title: "TENNPATTI T20",
    provider_code: "SN",
    game_code: "TP20",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/56968.webp",
    alt: "Hi-Low",
    title: "Hi-Low",
    provider_code: "SN",
    game_code: "AB2",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/98790.webp",
    alt: "Dragon Tiger",
    title: "Dragon Tiger",
    provider_code: "EZ",
    game_code: "150",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67630.webp",
    alt: "Teenpatti Test",
    title: "Teenpatti Test",
    provider_code: "EZ",
    game_code: "227100",
  },
  // {
  //   img: "https://auraimgs.imgix.net/indian%20games%20posters-01.webp?q=65&w=625&ar=0.75&px=auto&auto=format&fit=fill&blur=0",
  //   alt: "7UP 7DOWN",
  //   title: "7UP 7DOWN",
  //   provider_code: "EZ",
  //   game_code: "507000",
  // },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67580.webp",
    alt: "Casino War",
    title: "Casino War",
    provider_code: "SN",
    game_code: "RCQ",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67620.webp",
    alt: "Queen Race",
    title: "Queen Race",
    provider_code: "SN",
    game_code: "RCQ20",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/98788.webp",
    alt: "Roulette",
    title: "Roulette",
    provider_code: "EZ",
    game_code: "221003",

  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67610.webp",
    alt: "The Trio",
    title: "The Trio",
    provider_code: "SN",
    game_code: "VJKR",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67567.webp",
    alt: "Poker 20-20",
    title: "Poker 20-20",
    provider_code: "QT",
    game_code: "BTV-6poker",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67600.webp",
    alt: "Muflis Teenpatti",
    title: "Muflis Teenpatti",
    provider_code: "SN",
    game_code: "MTP7M",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/92038.webp",
    alt: "Baccarat",
    title: "Baccarat",
    provider_code: "SN",
    game_code: "BAC",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67570.webp",
    alt: "Bollywood Casino",
    title: "Bollywood Casino",
    provider_code: "SN",
    game_code: "ARW",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/90100.webp",
    alt: "Race 2020",
    title: "Race 2020",
    provider_code: "SN",
    game_code: "VCR",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/92037.webp",
    alt: "Matka",
    title: "Matka",
    provider_code: "SN",
    game_code: "VWM",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/67565.webp",
    alt: "6 Player Poker",
    title: "6 Player Poker",
    provider_code: "QT",
    game_code: "BTV-6poker",
  },
  {
    img: "https://img.jaipurapps.com/new-casino-img/betgamestv/Bet-On-Poker.webp",
    alt: "Poker",
    title: "Poker",
    provider_code: "QT",
    game_code: "BTV-betonpoker",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/56967.webp",
    alt: "32 Cards Casino",
    title: "32 Cards Casino",
    provider_code: "SN",
    game_code: "C32",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/98566.webp",
    alt: "Sicbo",
    title: "Sicbo",
    provider_code: "QT",
    game_code: "HAB-sicbo",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/87564.webp",
    alt: "Andar Bahar",
    title: "Andar Bahar",
    provider_code: "SN",
    game_code: "AB",
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/98791.webp",
    alt: "Amar Akbar Anthony",
    title: "Amar Akbar Anthony",
    provider_code: "SN",
    game_code: "ARW",
  },
  {
    img: "https://img.jaipurapps.com/new-casino-img/royalgaming/Super-Over.webp",
    alt: "super over",
    title: "super over",
    provider_code: "SN",
    game_code: "VUD7", 
  },
  {
    img: "https://img.jaipurapps.com/all-casino-img/radhe/56767.webp",
    alt: "Teenaptti open",
    title: "Teenaptti open",
    provider_code: "SN",
    game_code: "V3TP",
  },
  // {
  //   img: "https://auraimgs.imgix.net/indian%20games%20posters-17.webp?q=65&w=625&ar=0.75&px=auto&auto=format&fit=fill&blur=0",
  //   alt: "dream catcher",
  //   title: "dream catcher",
  //   provider_code: "GT",
  //   game_code: "bangkokdreams",
  // },
  // {
  //   img: "https://auraimgs.imgix.net/indian%20games%20posters-27.webp?q=65&w=625&ar=0.75&px=auto&auto=format&fit=fill&blur=0",
  //   alt: "3 card judgement",
  //   title: "3 card judgement",
  //   provider_code: "EZ",
  //   game_code: "227100",
  // },
  // {
  //   img: "https://auraimgs.imgix.net/indian%20games%20posters-29.webp?q=65&w=625&ar=0.75&px=auto&auto=format&fit=fill&blur=0",
  //   alt: "29 card baccarat",
  //   title: "29 card baccarat",
  //   provider_code: "QT",
  //   game_code: "MSG-baccarat",
  // },
];

const Indiancardgames = () => {
  const [showLoginModel, setShowLoginModel] = useState(false);
  const scrollRef = useRef(null);
  const userInfo = Helper();

  const [loaderPercent, setLoaderPercent] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const loaderIntervalRef = useRef(null);

  const scrollByAmount = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: amount, behavior: "smooth" });
    }
  };

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    startLoader();

    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        } else if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
        stopLoader();
      })
      .catch(function (error) {
        stopLoader();
        console.log(error);
      });
  }

  function startLoader() {
    setLoaderPercent(0);
    setShowLoader(true);
    if (loaderIntervalRef.current) clearInterval(loaderIntervalRef.current);
    loaderIntervalRef.current = setInterval(() => {
      setLoaderPercent(prev => (prev >= 90 ? 90 : prev + 5));
    }, 80);
  }

  function stopLoader() {
    if (loaderIntervalRef.current) clearInterval(loaderIntervalRef.current);
    setLoaderPercent(100);
    setTimeout(() => {
      setShowLoader(false);
      setLoaderPercent(0);
    }, 400);
  }

    // Loader SVG ring calculation
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const progress = loaderPercent / 100;
  const strokeDashoffset = circumference * (1 - progress);

  useEffect(() => {
    return () => {
      if (loaderIntervalRef.current) clearInterval(loaderIntervalRef.current);
    };
  }, []);

  return (
    <div title="Indian Card Games" className="py-[10px] w-full">
      {showLoader && (
        <div className="preloader">
          <div className="loader-container">
            <svg className="progress-ring" width="100" height="100">
              <circle
                className="progress-ring-bg"
                cx="50"
                cy="50"
                r={radius}
                style={{ stroke: 'rgba(255,255,255,0.1)', strokeWidth: 2, fill: 'transparent' }}
              ></circle>
              <circle
                className="progress-ring-circle"
                cx="50"
                cy="50"
                r={radius}
                style={{
                  stroke: 'var(--color-accent-1)',
                  strokeWidth: 2,
                  fill: 'transparent',
                  strokeDasharray: circumference,
                  strokeDashoffset,
                  transition: 'stroke-dashoffset 0.3s linear'
                }}
              ></circle>
            </svg>
            <div className="loader-content">
              <div className="loading-stage">
                <div className="stage-current">Loading</div>
                <div className="stage-next">Ready</div>
              </div>
              <div className="percentage">{loaderPercent}</div>
            </div>
          </div>
          <div className="loader-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>
      )}
      <div className="flex flex-col w-full font-lato bg-bg_color_primary rounded-[10px] divide-y-[1px] divide-border_color_primary shadow-homeCasinoCardGamesShadow">
        <div className="w-[100%] flex flex-row justify-between px-3 py-1.5">
          <div className="max-w-[85%] text-text_color_primary1 font-semibold capitalize cursor-pointer">
            <div className="flex items-center w-full gap-x-2">
              {/* SVG ICON */}
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 511.643 511.643">
                <g>
                  <path
                    d="M453.209 184.081C373.725 121.725 300.804 41.437 270.565 6.713c-7.795-8.951-21.691-8.951-29.486 0-30.24 34.723-103.16 115.011-182.644 177.368C22.372 212.373 1.267 254.915 1.267 299.99c0 80 66.652 144.853 148.871 144.853 27.807 0 53.101-10.455 71.97-27.539v28.247c0 34.386-24.644 38.65-43.766 54.707-4.599 3.862-1.775 11.384 4.23 11.384h145.994c5.984 0 8.811-7.47 4.262-11.358-18.926-16.176-43.294-19.786-43.294-54.478v-28.503c18.869 17.084 44.163 27.539 71.97 27.539 82.219 0 148.871-64.853 148.871-144.853.001-45.074-21.104-87.616-57.166-115.908z"
                    fill="var(--icon-color-brand-primary)"
                  />
                </g>
              </svg>
              <span className="text-text_color_primary1 font-semibold capitalize">
                Indian Card Games
              </span>
            </div>
          </div>
          <div className="flex w-[108.75px] items-center justify-end gap-[5px]">
            <button
              className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out font-lato bg-bg_text_brand_secondary text-transparent bg-clip-text font-semibold text-[12px] leading-[18px] transition-all ease-in-out duration-200 cursor-pointer"
              type="button"
            >
              See All
            </button>
            <button
              className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out flex w-[22px] h-[22px] justify-center items-center bg-bg_color_quaternary rounded border cursor-pointer"
              type="button" onClick={() => scrollByAmount(-300)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M15 6l-6 6l6 6"></path>
              </svg>
            </button>
            <button
              className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out flex w-[22px] h-[22px] justify-center items-center bg-bg_color_quaternary rounded border cursor-pointer"
              type="button" onClick={() => scrollByAmount(300)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--icon-color-brand-secondary)" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
            </button>
          </div>
        </div>
        <div
          title="Indian Card Games"
          className="p-2.5 transition-all ease-in-out duration-200 w-full gap-1 overflow-x-auto scroll-smooth no-scrollbar grid grid-flow-col grid-rows-3"
          ref={scrollRef}
        >
          {indianGames.map((game, idx) => (
            <div
              key={idx}
              title={game.title}
              className="min-w-[120px] sm:min-w-[140px] md:min-w-[160px] lg:min-w-[180px] xl:min-w-[200px] 2xl:min-w-[220px] aspect-square rounded-md cursor-pointer overflow-hidden"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (!userInfo || !userInfo._id) {
                  setShowLoginModel(true);
                } else if(game.provider_code && game.game_code) {
                  CreateAndLaunchWCOCasino(game.provider_code, game.game_code, "casino");
                }
              }}
            >
              <div className="relative overflow-hidden w-full h-full object-cover">
                <img
                  src={game.img}
                  alt={game.alt}
                  sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 625px"
                  className="w-full h-full object-cover active:scale-105 hover:scale-105 transition-all ease-in-out duration-200"
                  loading="lazy"
                  title={game.title}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Login
        showPopup={showLoginModel}
        togglePopup={() => setShowLoginModel(false)}
        // Pass other required props here
      />
    </div>
  );
};

export default Indiancardgames;